const initialState = {
  servicesAbout: [],
  isLoading: null,
  isError: null,
};

export default initialState;
